import React, { useEffect } from 'react';
import { Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import WebQrsList from '../components/WebQrsList';
import useWebQrs from '../useWebQrs';

const WebQrsMain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const {
    webQrs,
    loading,
    total,
    currentPage,
    pageSize,
    filters,
    shoppingCenters,
    loadingCompanies,
    fetchWebQrs,
    handleDelete,
    setFilters,
    setCurrentPage,
    setPageSize,
  } = useWebQrs();

  useEffect(() => {
    fetchWebQrs();
  }, [fetchWebQrs]);

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  return (
    <Card
      title={
        <span style={{ fontSize: '24px', fontWeight: '600' }}>
          {t('QR Code Generator')}
        </span>
      }
      extra={
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => navigate('new')}
          style={{
            marginBottom: 12,
            width: '140px',
            height: 48,
            backgroundColor: '#002637',
            borderColor: '#002637',
          }}
        >
          {t('Nuovo')}
        </Button>
      }
    >
      <WebQrsList
        webQrs={webQrs}
        loading={loading}
        total={total}
        currentPage={currentPage}
        pageSize={pageSize}
        filters={filters}
        shoppingCenters={shoppingCenters}
        loadingCompanies={loadingCompanies}
        onFiltersChange={updateFilters}
        onPageChange={handlePageChange}
        handleDelete={handleDelete}
      />
    </Card>
  );
};

export default WebQrsMain;
